import { render } from "./NewsDialog.vue?vue&type=template&id=559d1683"
import script from "./NewsDialog.vue?vue&type=script&lang=js"
export * from "./NewsDialog.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/news/NewsDialog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "559d1683"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('559d1683', __exports__)) {
    console.log('reload')
    api.reload('559d1683', __exports__)
  }
  
  module.hot.accept("./NewsDialog.vue?vue&type=template&id=559d1683", () => {
    console.log('re-render')
    api.rerender('559d1683', render)
  })

}


export default __exports__